import { useTheme } from "react-admin";

import { isThemeType } from "../isThemeType";

export const useLayoutMode = () => {
  const [theme] = useTheme();

  return isThemeType(theme) ? theme : "light";
};
